// extracted by mini-css-extract-plugin
module.exports = {"themeHeaderIconColor":"#fff","themeIconColor":"#0f4c81","themeDisabledIconColor":"#cdcdcd"};